import Error from "./emptyType3";

export { Error };
export default Error;
